import { Typography } from "@mui/material";
import videoChainsaw from './assets/chainsawVideo.mov';
import imgOpacityPhoto from './assets/opacityPhoto.png';

import './purpleairWebpage.css';


const PageRegulatoryDifficult = () => {

    return (<>
        <div className='pageContainer' >
            <div className='pageInnerContainer'>
                <Typography variant="h5" gutterBottom>Why Regulations Have Been Ineffective</Typography>
                <p>Given the known significant health risks caused by airborne concrete dust, you are probably wondering
                    how the facility continues to operate in close proximity to a residental neighborhood.  Unfortunately due to
                    the nature of concrete crushing, it slips through the cracks of the current regulatory framework.</p>

                <Typography variant="h5" gutterBottom>Loophole in the Clean Air Act</Typography>
                <p>The Clean Air Act does have guidance when it comes to the very harmful small airborne concrete shards that are
                    generated by concrete crushing.  The Act uses <i>Air Quality Index</i> (or "AQI") categories for guidance on
                    safe levels of particles. Unfortunately those standards are based upon <b>daily averages</b>.
                </p>
                <p>Unlike other industrial processes that run continueously, concrete crushing is done in a batch.  It is
                    similar to a power tool. When the machine is running, it generates a lot of dust.  When you turn it off, the dust
                    stops.
                </p>
                <video width="100%" height="360" controls>
                    <source src={videoChainsaw} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
                <p>So even if the U.S. Recycling was operating at the most hazardous category
                    (which the EPA consideres a serious health risk for everyone) for just one hour and then stopped for the day,
                    the daily average would be considered <i>acceptable</i> under the Clean Air Act.
                </p>
                <Typography variant="h5" gutterBottom>Visible Emissions Loophole</Typography>
                <p>The Florida Department of Environmental Protection also uses the opacity caused by the poluting source
                    as an alternative measure for addressing harmful operations.  The state standard, which is used by Sarasota
                    County has a threshold of 20% opacity.
                </p>
                <img src={imgOpacityPhoto} style={{ width: '100%', marginBottom: '-20px' }} alt='example of 20 percent opacity' />
                <p>Opacity regulations are most useful for pollution that consists of large particles.  The bigger the particle, the more sun they block.
                </p><p>
                    Concrete dust measures just 2.5 microns or smaller.  They are small enough to be absorbed into your lungs and bloodstream, but because
                    they are so tiny, it takes a large amount to block sunlight (which is what opacity measures).
                </p>
                <p>
                    So in order to reach 20% opacity, U.S. Recycling would be emitting at the most danagerous level -- causing serious health effects for everyone.
                </p>
                <Typography variant="h5" gutterBottom>Where Do We Go From Here</Typography>
                <p>
                    Operating open-air concrete crushing in such close proximity to a residential community is inherently unhealthy. We must revise
                    our local regulations to prevent such incompatible industrial practices within residential communities.
                </p>
                <Typography variant="h6" gutterBottom>Better - Hillsborough County</Typography>
                <p>Hillsborough County adopted more stringent local standards than used by Sarasota.
                    They have a 5% opacity for visual emissions testing compared to the 20% FDEP standard.  That equates to
                    a corresponding AQI value 67 (unheathly-everyone may experience effects) but significantly lower than the highly toxic 269 AQI required to breach the 20% opacity threshold.
                </p>
                <Typography variant="h6" gutterBottom>Best - Orange County</Typography>
                <p>Orange County also adopted more stringent local standards than used by Sarasota.
                    For example, Orange County's Zoning Code requires that "...use or operation that will have equipment or machines,
                    including a crusher, stockpiles, or loading/unloading activity...shall be at least one thousand (1,000) feet from
                    the nearest property line of any residential zoned district, residential use, or school."</p>
                <p>These stringent standards would have prevented U.S. Recycling from crushing concrete within the Central Cocoanut neighborhood.</p>

                <Typography variant="h6" gutterBottom style={{ marginTop: '50px' }}>Supporting Calculations</Typography>
                <p><i>Clean Air Act loophole:</i> 1 hour at 230 AQI ("very unhealthy") then 23 hours at 50 AQI (highest value considered "good") would result
                 in a daily average of 68 AQI, which is considered "moderate" meaning unusually sensitive people such as 
                 those with respiratory or heart disease, the elderly and children should consider reducing prolonged or 
                 heavy exertion while outside.
                </p>
                <p><i>Visible emissions loophole:</i> A general (empirical) rule in visibility science is that:
                </p>
                <ul>
                    <li style={{ paddingBottom: "10px" }}>Visual range (km) ≈ 3.912 / bₛcₐₜ (Mm⁻¹)<br />
                        This can be rearranged to estimate bₛcₐₜ from visibility or apparent opacity.</li>
                    <li style={{ paddingBottom: "10px" }}>Empirical observations (from EPA data and visibility studies) show:<br />
                        20% opacity generally corresponds to a scattering coefficient between 400–600 Mm⁻¹ at the source, depending on particle type, size distribution, and humidity.
                    </li>
                    <li style={{ paddingBottom: "10px" }}>When the monitor situated 350 feet away from U.S. Recycling measured a scattering coefficient of 160
                        with an AQI value of 86, it can be extrapolated that a scattering coefficient of 500 would have resulted in an AQI of 269.
                    </li>
                </ul>


            </div>

        </div>
    </>);
}

export default PageRegulatoryDifficult;